import React from 'react';
import InfoBox from 'components/widget/InfoBox';
import PropTypes from 'prop-types';
import ProductPrice from 'components/ProductPrice';
import styled from 'styled-components';

const Wrapper = styled(InfoBox)`
  color: ${({ theme }) => theme.palette.text.light};
  .ProductPrice {
    display: inline;
  }
`;

const Component = ({ nextPaymentAmount, currency }) => (
  <Wrapper>
    Because you still have an outstanding payment on your last order, your next
    payment will be&nbsp;
    <ProductPrice currency={currency} price={nextPaymentAmount} />
  </Wrapper>
);

Component.propTypes = {
  nextPaymentAmount: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    frequency: PropTypes.string,
  }).isRequired,
  currency: PropTypes.string.isRequired,
};

export default Component;
